// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
const companyCode = 'KT';
export const environment = {
  companyCode: companyCode,
  production: false,
  "isPaymentHit": true,
  isAllowedCancellation: true,
  website: "kanhatravel.com",
  defaultGateway: "CCAvenue",
  logoName: "kanhaTravel",
  companyShortName: "kanhaTravel",
  companyFullName: "kanhaTravel",
  mobileNo: "(+91) 9971-27-0406",
  emailId: "info@kanhatravel.com",
  "AppRedirectURLFlight": "https://sourcemytrip.co/flight-payment",
  "AppRedirectURLHotel": "https://sourcemytrip.co/hotel-payment",
  //"AppRedirectURLHotel": "http://localhost:4200/hotel-payment",
  "AppRedirectURLSightseeing": "https://sourcemytrip.co/sightseeing/sightseeing-payment",
  "AppRedirectURLHoliday": "https://sourcemytrip.co/holiday/holiday-payment",
  "AppRedirectURLTransfer": "https://sourcemytrip.co/transfer/transfer-payment",

  UtilityBaseURL: 'https://SriUtilityApi.travelportal24.com/',
  GenericBaseURL: 'https://SriGenericApi.travelportal24.com/',
  //GenericBaseURL: 'http://localhost:51524/',
  PaymentInitiateURL: 'https://payment.sourcemytrip.co/PaymentSrv.asmx/PaymentInitiate',
  PaymentURL: "https://payment.sourcemytrip.co/API/PaymentWaiting.aspx?PG=",
  HotelBaseURL: 'https://SriHotelApi.travelportal24.com/',
  //HotelBaseURL: 'http://localhost:62216/',
  FlightBaseURL: 'https://SriFlightApi.travelportal24.com/',
  //FlightBaseURL: 'http://localhost:53734/',
  PackageBaseURL: 'https://SriPackageApi.travelportal24.com/',
  SightseeingBaseURL: 'https://SriSeightseeingApi.travelportal24.com/',
  TransferBaseURL: 'https://SriTransferApi.travelportal24.com/',
  //Common Info
  facebookLink: "https://www.facebook.com/RamDasInfotech/",
  instagramLink: "https://www.instagram.com/ramdasinfotech/",
  twitterLink: "https://twitter.com/ramdasinfotech/",
  linkedinLink: "https://www.linkedin.com/company/Ramdasinfotech",
  address: "A-441 B, 4th Floor, Golden I,Tower A, Sec- Techzone 4, Greater Noida West, UP - 201009",
  about: "One of the leaders in the Indian travel industry, KanhaTravel is the go-to platform for your travel needs. Find the best online flight tickets booking and hotel booking deals, and save money every time you hit the road for business or leisure.",
  DomainUrl: "https://kanhatravel.com/",
  WebsiteTitle: "Kanha Travel Booking Engine"
};


